import CryptoJS from "crypto-js";
const LOCAL_STORAGE_KEY = "8b89a4a4a3c06fa42a2bb08136652ad8";

export const getProductDetailBasedonProduct = (productId) => {
  let result = {};
  result["productName"] = "FC Assets - Trial";
  result["productType"] = "Free";

  switch (productId) {
    case "358603F4-DC47-4C76-AC30-42B3EFA883CB":
      result["productName"] = "FC Measurements";
      result["productType"] = "Free";
      break;

    case "04A8D2E4-48A5-48B4-9213-4B48BF185179":
      result["productName"] = "FC Assets - Trial";
      result["productType"] = "Free";
      break;

    case "14831503-4AE8-41CF-924F-12627CEE49E0":
      result["productName"] = "FC Assets";
      result["productType"] = "Paid";
      break;

    case "16ECE06B-06A9-4D16-AD56-BDBE23587911":
      result["productName"] = "FC Assets - Original User";
      result["productType"] = "Free";
      break;

    case "4381d1b6-13cf-4bc7-88d5-b775cefd127c":
      result["productName"] = "FC Condition Monitoring";
      result["productType"] = "Paid";
      break;

    case "20ed36da-fc0e-4a66-9fd2-c84870f0ff58":
      result["productName"] = "FC Condition Monitoring - Vibration";
      result["productType"] = "Paid";
      break;

    case "99341615-91e6-4e15-826a-7a7047a7fa82":
      result["productName"] = "FC Condition Monitoring - Thermal";
      result["productType"] = "Paid";
      break;

    case "9a0a6b89-8fb1-4351-b633-c4f703fc2e56":
      result["productName"] = "FC Condition Monitoring - Power";
      result["productType"] = "Paid";
      break;

    case "355773a7-edcf-4887-a79e-731c0e179ad1":
      result["productName"] = "FC Condition Monitoring - Electrical";
      result["productType"] = "Paid";
      break;

    default:
      result["productName"] = "FC Assets - Trial";
      result["productType"] = "Free";
      break;
  }
  return result;
};

export const includesInString = (str, subStr) => {
  if (str && str.indexOf(subStr) > -1) return true;
  else return false;
};

export const convertToHrs = (startTime, endTime) => {
  let hrs = (endTime - startTime) / (60 * 60 * 1000);
  return hrs.toFixed(2);
};

export const getDuration = (startTime, endTime) => {
  let seconds, days, hours, minutes;
  seconds = Math.abs(endTime - startTime) / 1000;
  days = Math.floor(seconds / 86400);
  seconds -= days * 86400;
  hours = Math.floor(seconds / 3600) % 24;
  seconds -= hours * 3600;
  minutes = Math.floor(seconds / 60) % 60;
  return { days: days, hours: hours, minutes: minutes };
};

export const convertFtoC = (temperature) => ((temperature - 32) * 5) / 9;

export const convertCtoF = (temperature) => (temperature * 9) / 5 + 32;

export const convert_F_to_C = (unitValue, noOfDecimalPoints) => {
  return (((unitValue - 32) * 5) / 9).toFixed(noOfDecimalPoints);
};

export const convert_C_to_F = (unitValue, noOfDecimalPoints) => {
  return ((unitValue * 9) / 5 + 32).toFixed(noOfDecimalPoints);
};

export const encryptData = (data) => {
  const encrypted = CryptoJS.AES.encrypt(data, LOCAL_STORAGE_KEY).toString();
  return `ENCRYPTED:${encrypted}`;
};

export const decryptData = (data) => {
  if (!data) return null;
  if (data && (data.startsWith("ENCRYPTED:") || data.startsWith("U2F"))) {
    const encryptedData = data.startsWith("ENCRYPTED:")
      ? data.substring("ENCRYPTED:".length)
      : data;
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(
        encryptedData,
        LOCAL_STORAGE_KEY,
      );
      const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return decryptedData;
    } catch (error) {
      console.error("Error decrypting data:", error);
      return null;
    }
  } else {
    // Not encrypted, just return as is
    return data;
  }
};
